import React from "react";
import bgImage1 from "../assets/Oil-and-Gas.jpg";
import leader from "../assets/leader.jpg";
import welding from "../assets/welding.jpg";
import planning from "../assets/planning.jpg";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import "../styles/Home.css";
import AOS from "aos";
import "aos/dist/aos.css";
import CountUp from "react-countup";
import ScrollTrigger from "react-scroll-trigger";
function Home() {
  const [showHeader, setShowHeader] = useState(false);
  const [counterOn, setCounterOn] = useState(false);

  const handleScrollEnter = () => {
    setCounterOn(true);
  };

  const handleScrollExit = () => {
    setCounterOn(false);
  };

  const scrollToContact = () => {
    const contactSection = document.getElementById("contact");
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  const scrollToTop = () => {
    const contactSection = document.getElementById("navbar");
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    AOS.init();
    setShowHeader(true);
  }, []);
  return (
    <div className=" border-red-600">
      <div className="flex flex-col justify-center h-screen relative border-black bg-gradient-to-br from-black via-gray-950  ">
        <div
          className="absolute inset-0 opacity-20"
          style={{
            backgroundImage: `url(${bgImage1})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        ></div>

        <div className="px-40 z-10">
          <h1
            className={`border-black text-7xl text-white font-poppins font-[700] whitespace-nowrap z-10 transition-opacity duration-[3000ms] ${
              showHeader ? "opacity-100" : "opacity-0"
            }`}
          >
            <p className="leading-snug text-white">
              TO BE THE{" "}
              <span
                style={{
                  color: "transparent",
                  WebkitTextFillColor: "transparent", // For Safari/WebKit browsers
                  WebkitTextStrokeWidth: "2px", // For Safari/WebKit browsers
                  WebkitTextStrokeColor: "#FFF", // For Safari/WebKit browsers
                  textStrokeWidth: "2px",
                  textStrokeColor: "#FFF",
                }}
              >
                LEADER
              </span>
            </p>{" "}
            <p className="text-3xl font-[400]">
              bridge the gap between conventional
            </p>
            <div className="flex w-full">
              <p className="text-3xl font-[400] text-white leading-snug font-poppins  whitespace-nowrap z-10">
                and innovative solutions
              </p>
            </div>
          </h1>
        </div>
      </div>

      <div className="flex">
        <div className="flex flex-col bg-white border-black w-full h-auto p-40 items-center">
          <div
            className="flex flex-col group border-black items-center"
            data-aos="fade-up"
          >
            <p className="font-poppins font-bold text-5xl leading-snug">
              A{" "}
              <span className="group-hover:text-secondary transition-colors duration-100">
                dynamic
              </span>{" "}
              and{" "}
              <span className="group-hover:text-secondary transition-colors duration-100">
                enthusiastic
              </span>{" "}
              team with various{" "}
            </p>
            <p className="font-poppins font-bold text-5xl leading-snug">
              backgrounds in{" "}
              <span className="group-hover:text-secondary transition-colors duration-100">
                {" "}
                engineering
              </span>
              ,{" "}
              <span className="group-hover:text-secondary transition-colors duration-100">
                finance
              </span>
              , and{" "}
            </p>
            <p className="font-poppins font-bold text-5xl leading-snug">
              <span className="group-hover:text-secondary transition-colors duration-100">
                management
              </span>{" "}
              drives Vision One.
            </p>

            {/* <h1 className=" font-[700] font-poppins text-5xl mb-4 leading-snug">
              A{" "}
              <span className="group-hover:text-secondary transition-colors duration-100">
                dynamic
              </span>{" "}
              and{" "}
              <span className="group-hover:text-secondary transition-colors duration-100">
                enthusiastic
              </span>{" "}
              team with various backgrounds in

              <span className="group-hover:text-secondary transition-colors duration-100">
                {" "}
                engineering
              </span>
              ,{" "}
              <span className="group-hover:text-secondary transition-colors duration-100">
                finance
              </span>
              , and{" "}
              <span className="group-hover:text-secondary transition-colors duration-100">
                management
              </span>{" "}
              drives Vision One.
            </h1> */}

            <h1
              className="font-poppins text-lg mt-16"
              style={{ color: "#7A8384" }}
            >
              We aim to progress further in the Global Energy build our
              hard-earned reputation as a reliable contractor with integrity.
            </h1>
          </div>
          <button className=" mt-20 px-8 py-4 border-black border-2 rounded-md hover:bg-secondary hover:border-secondary hover:text-white duration-500">
            <a href="/about">
              <h1 className="font-poppins">Read About Us</h1>
            </a>
          </button>
        </div>
      </div>

      <div
        className="flex flex-col p-40 font-poppins"
        style={{ backgroundColor: "#F5F5F5" }}
      >
        <div className="flex justify-between">
          <h1 className="font-[700] text-5xl">
            We Provide <span className=" text-secondary">Solutions</span>
          </h1>
          <button className="text-secondary font-[600] underline">
            <a href="/services">See More &gt;</a>
          </button>
        </div>

        <p className="font-[400] text-xl text-[#7A8384] text-justify mt-16">
          Vision One utilizes the skills of its management employees and
          associates to support and consultation in the oil and gas industry,
          petrochemical and marine operation
        </p>

        <div className="flex flex-row mt-20 gap-32 border-black ">
          <div
            className="flex flex-col w-full border-black shadow-lg"
            data-aos="fade-up"
          >
            <img
              src={require("../assets/firstPic.jpg")}
              alt="Your Image"
              className="flex-shrink-0 w-full object-cover h-60"
            />
            <div className="flex flex-col w-full h-full border-black justify-center py-6 px-10 rounded-bl-md rounded-br-md shadow-lg">
              <div className="flex border-black h-full items-center">
                <h1 className="font-[600] text-lg">
                  Manpower Resources Inspection and Testing
                </h1>
              </div>

              <button className=" mb-6 mt-12 px-8 py-4 border-black border-2 rounded hover:bg-secondary hover:border-secondary hover:text-white duration-500">
                <a href="/services">
                  <h1 className="font-poppins">Read More</h1>
                </a>
              </button>

              {/* <div className="flex flex-col justify-center py-6 px-10 border-black border-2">
            
          </div> */}
            </div>
          </div>

          <div
            className="flex flex-col w-full border-black shadow-lg"
            data-aos="fade-up"
          >
            <img
              src={require("../assets/secondPic.jpg")}
              alt="Your Image"
              className="flex-shrink-0 w-full object-cover h-60"
            />
            <div className="flex flex-col w-full h-full border-black justify-center py-6 px-10 rounded-bl-md rounded-br-md shadow-lg">
              <div className="flex border-black h-full items-center">
                <h1 className="font-[600] text-lg">
                  Integrity Inspection and Non destructive Testing (NDT)
                </h1>
              </div>

              <button className=" mb-6 mt-12 px-8 py-4 border-black border-2 rounded hover:bg-secondary hover:border-secondary hover:text-white duration-500">
                <a href="/services">
                  <h1 className="font-poppins">Read More</h1>
                </a>
              </button>

              {/* <div className="flex flex-col justify-center py-6 px-10 border-black border-2">
            
          </div> */}
            </div>
          </div>

          <div
            className="flex flex-col w-full border-black shadow-lg"
            data-aos="fade-up"
          >
            <img
              src={require("../assets/thirdPic.jpg")}
              alt="Your Image"
              className="flex-shrink-0 w-full object-cover h-60"
            />
            <div className="flex flex-col w-full h-full border-black justify-center py-6 px-10 rounded-bl-md rounded-br-md shadow-lg">
              <div className="flex border-black h-full items-center">
                <h1 className="font-[600] text-lg">
                  Fabrication, Manufacturing, Maintenance and Repair
                </h1>
              </div>

              <button className=" mb-6 mt-12 px-8 py-4 border-black border-2 rounded hover:bg-secondary hover:border-secondary hover:text-white duration-500">
                <a href="/services">
                  <h1 className="font-poppins">Read More</h1>
                </a>
              </button>

              {/* <div className="flex flex-col justify-center py-6 px-10 border-black border-2">
            
          </div> */}
            </div>
          </div>
        </div>
      </div>

      <div className="flex flex-col p-40 font-poppins">
        <div className="flex justify-between border-black">
          <h1 className="font-[700] text-5xl">Our Experiences</h1>
          <button className="text-secondary font-[600] underline">
            <a
              href="https://drive.google.com/file/d/1ao8MqWRiEKy_ctKJrqQ695qapCgmSlPo/view?usp=sharing"
              target="_blank"
            >
              Projects List&gt;
            </a>
          </button>
        </div>

        <ScrollTrigger onEnter={handleScrollEnter} onExit={handleScrollExit}>
          <div className="flex flex-row gap-10 border-black  mt-16 ">
            <p className="font-[400] text-xl w-1/3 text-[#7A8384]">
              We are committed to the mission of upholding the value of customer
              convictions and services proficiency detailed with precision.
            </p>

            <div className="flex-1 flex justify-end flex-row border-black">
              <div className=" flex flex-1 flex-col gap-4 border-black items-center">
                <h1 className="font-[700] text-secondary text-8xl ">
                  {counterOn && (
                    <CountUp start={0} end={27} delay={0}></CountUp>
                  )}
                </h1>

                <p className="text-[#7A8384]">Year of Services</p>
              </div>
              <div className="flex flex-1 flex-col gap-4  border-black items-center">
                <h1 className="font-[700] text-secondary text-8xl ">
                  {counterOn && (
                    <CountUp start={0} end={40} delay={0}></CountUp>
                  )}
                  +
                </h1>

                <p className="text-[#7A8384]">Clients</p>
              </div>
              <div className="flex flex-1 flex-col gap-4 border-black items-center">
                <h1 className="font-[700] text-secondary text-8xl">
                  {counterOn && (
                    <CountUp start={0} end={147} delay={0}></CountUp>
                  )}
                </h1>

                <p className="text-[#7A8384]">Projects</p>
              </div>
            </div>
          </div>
        </ScrollTrigger>
      </div>

      <div
        className="flex flex-col gap-10 pt-10 p-40 font-poppins "
        data-aos="zoom-in-up"
      >
        <div className="flex flex-col gap-6 items-center bg-secondary py-32">
          <h1 className="font-[700] text-4xl text-white">Want to Know More?</h1>

          <h1 className="font-normal text-xl text-white">
            Get to know answers from our sales team in no matter of time!
          </h1>

          <button
            className="mt-14 px-8 py-4 border-white text-white border-2 rounded-md hover:bg-white hover:border-white  hover:text-secondary duration-500"
            type="button"
            data-drawer-target="drawer-contact"
            data-drawer-show="drawer-contact"
            aria-controls="drawer-contact"
          >
            <h1 className="font-poppins">Contact Sales</h1>
          </button>
        </div>

        <div className="flex flex-row  border-black justify-end">
          <button
            onClick={scrollToTop}
            class="text-white bg-gray-900 hover:bg-blue-500 duration-150 font-medium  text-md px-5 py-3"
          >
            <h1 className="text-5xl font">^</h1>
          </button>
        </div>
      </div>
    </div>
  );
}

export default Home;
